export const companySettingsTranslations = {
  ar: {
    // Tabs
    tabs: {
      basicData: 'البيانات الاساسية',
      accountConstants: 'ثوابت الحسابات',
      accountingData: 'البيانات المحاسبية',
      salesAndWarehouses: 'المبيعات والمخازن',
      general: 'عام',
      storageSettings: 'إعدادات التخزين',
    },
    // Basic Data Tab
    basicData: {
      logo: 'الشعار',
      mainPageLogo: 'شعار الصفحة الاساسية',
      commercialName: 'الاسم التجاري',
      address: 'العنوان',
      website: 'الموقع الالكتروني',
      email: 'البريد الالكتروني',
      phone: 'التليفون',
      mobile: 'الموبايل',
      taxNumber: 'الرقم الضريبي',
      timeZone: 'المنطقة الزمنية',
      timeZoneHint: 'تاريخ الفواتير والسندات يتبع هذه المنطقة. القيمة الحالية بيروت.',
      upload: 'رفع',
      delete: 'حذف',
      noPhoto: 'No Photo',
    },
    // Account Constants Tab
    accountConstants: {
      bank: 'بنك',
      otherRevenue: 'الإيرادات الأخرى',
      payable: 'الدفع المستحق',
      receivable: 'القبض المستحق',
      bankExpenses: 'مصاريف البنك والاستحقاقات',
      currencyExchangeGain: 'فوارق العملة ربح',
      currencyExchangeLoss: 'فوارق العملة خسارة',
      rawMaterialExpenses: 'مصاريف المواد الخام',
      totalExpenses: 'مصروفات (اجمالي)',
      capital: 'رأس المال',
      customer: 'العملاء',
      supplier: 'الموردين',
      costOfSales: 'تكلفة المبيعات',
      inventory: 'المخزون',
      salesRevenue: 'إيرادات المبيعات',
      creditAccounts: 'حسابات الائتمان',
      cash: 'النقدية',
      selectAccount: 'اختر الحساب',
      fixedAssetsSection: 'حسابات الأصول الثابتة',
      fixedAssetDefault: 'حساب الأصل الافتراضي',
      fixedAssetAccumDepr: 'مجمع الإهلاك الافتراضي',
      fixedAssetDeprExpense: 'مصروف الإهلاك الافتراضي',
      fixedAssetRoutineExpense: 'مصروف الصيانة الدورية',
      fixedAssetCapitalWip: 'أعمال تحت التنفيذ / صيانة رأسمالية',
      fixedAssetSaleGain: 'أرباح بيع الأصول',
      fixedAssetSaleLoss: 'خسائر بيع الأصول',
      fixedAssetSaleProceeds: 'متحصلات بيع الأصول',
      missingAccountsWarning: 'تنبيه: بعض حسابات الأصول الثابتة غير مضبوطة أو غير موجودة. يجب ضبطها قبل الإهلاك / الصيانة / البيع.',
      accountNotConfigured: 'الحساب غير مضبوط',
      accountNotFound: 'الحساب غير موجود',
    },
    // Accounting Data Tab
    accountingData: {
      defaultCurrency: 'العملة الافتراضية',
      selectCurrency: 'اختر العملة',
      currencySaved: 'تم حفظ العملة بنجاح',
      inventoryMethod: 'طريقة حساب المخزون',
      inventorySystem: 'نظام الجرد',
      selectInventorySystem: 'اختر نظام الجرد',
      periodicInventory: 'الجرد الدوري',
      continuousInventory: 'الجرد المستمر',
      fiscalYear: 'السنة المالية',
      selectFiscalYear: 'اختر السنة المالية',
      selectFiscalYearFromHeader: 'يرجى اختيار السنة المالية من الهيدر أعلاه',
      fiscalYearStartDate: 'تاريخ بداية السنة المالية',
      fiscalYearEndDate: 'تاريخ نهاية السنة المالية',
      secondaryCurrency: 'العملة الثانوية',
      selectSecondaryCurrency: 'اختر العملة الثانوية',
      secondaryCurrencySaved: 'تم حفظ العملة الثانوية بنجاح',
      periodicInventoryGuideTitle: 'مزايا وعيوب الجرد الدوري وكيفية الدمج',
      periodicInventoryAdvantagesTitle: 'ميزات نظام الجرد الدوري',
      periodicInventoryDisadvantagesTitle: 'عيوب الجرد الدوري (للمقارنة)',
      periodicInventoryIntegrationTitle: 'كيفية تشغيل الجرد الدوري مع الجرد المستمر',
      periodicInventoryAdvantages: {
        simple: 'البساطة: لا يتطلب تحديثًا مستمرًا للسجلات بعد كل عملية بيع أو شراء، ومناسب للشركات الصغيرة أو ذات المنتجات المحدودة.',
        lowCost: 'تكلفة أقل: لا يحتاج إلى أنظمة تقنية معقدة أو برامج متقدمة لمتابعة المخزون لحظيًا.',
        easyImplementation: 'سهولة التنفيذ: لا يتطلب تدريبًا مكثفًا للموظفين على أنظمة رقمية معقدة.',
        nonTraceableProducts: 'ملاءمة للمنتجات غير القابلة للتتبع الفردي مثل المواد الخام أو السلع الرخيصة.',
        fewerDailyErrors: 'تقليل الأخطاء اليومية: التحديث يتم دفعة واحدة في نهاية الفترة مع تركيز أعلى أثناء الجرد الفعلي.',
      },
      periodicInventoryDisadvantages: {
        noRealtime: 'لا يوفر رؤية فورية لمستويات المخزون.',
        hardToDetectTheft: 'صعوبة اكتشاف السرقات أو الهدر خلال الفترة.',
        stockoutRisk: 'قد يؤدي إلى انقطاع المخزون دون سابق إنذار.',
      },
      periodicInventoryIntegrationSteps: {
        purpose: 'تحديد الغرض من التشغيل: هل سيتم الاعتماد على الجرد الدوري بالكامل أم استخدامه للمقارنة المحاسبية مع الجرد المستمر؟',
        dailyRecording: 'سلوك العمليات اليومية: تُسجَّل المشتريات في حساب المشتريات والمبيعات في حساب المبيعات دون تأثير مباشر على المخزون أو تكلفة البضاعة المباعة.',
        periodClose: 'إقفال الفترة: إدخال الجرد الفعلي مرة واحدة في نهاية الفترة وحساب تكلفة البضاعة المباعة بالمعادلة: مخزون أول المدة + صافي المشتريات - مخزون آخر المدة.',
        adjustments: 'تسجيل فروق الجرد: إثبات العجز أو الفائض وفقًا للفرق بين الرصيد الدفتري والجرد الفعلي.',
        documentation: 'توثيق الإقفال: حفظ تاريخ الإقفال والمسؤول والقيم المعتمدة لضمان المراجعة والرقابة.',
        reports: 'تقارير محاسبية: تكلفة البضاعة المباعة بطريقة الجرد الدوري، ومقارنة الرصيد الدفتري بالفعلي عند الحاجة.',
      },
    },
    // Sales and Warehouses Tab
    salesAndWarehouses: {
      salesDiscountAccount: 'حساب خصم المبيعات',
      purchaseDiscountAccount: 'حساب خصم المشتريات',
      servicesAccount: 'حساب الخدمات',
      quantityWarning: 'عند عدم توافر الكمية المطلوبة لصنف في المخزن',
      quantityWarningOptions: {
        noWarning: 'لا تحذرني',
        warn: 'تحذرني',
        preventSale: 'منع البيع',
      },
      sellAccount: 'حساب البيع',
      cashInvoiceCashbox: 'خزينة الفواتير النقدية',
      cashInvoiceCustomer: 'عميل الفواتير النقدية',
      selectCustomer: 'اختر العميل',
      inventoryAdjustmentAccount: 'حساب تسوية المخزون',
      costOfSalesAccount: 'حساب تكلفة المبيعات',
      costDifferenceAccount: 'حساب فروق التكلفة',
      giftAccount: 'حساب الهدايا',
      useCustomerCreditLimit: 'تطبيق حد ائتماني للعملاء',
      yes: 'نعم',
      no: 'لا',
      customerCreditLimitValue: 'قيمة الحد الائتماني',
      creditLimitWarning: 'عندما يتخطى العميل حد ائتمانة',
      inventoryAccount: 'حساب المخزون',
      invoiceAdditionalsAccount: 'حساب اضافات الفواتير',
      penalties: 'غرامات',
      cashInvoiceStore: 'مخزن الفواتير النقدية',
      selectStore: 'اختر المخزن',
      reserveQtyFromSalesOrders: 'حجز الكميات من طلبات البيع',
      select: 'اختر',
    },
    // General Tab
    general: {
      dateSettings: 'إعدادات التاريخ',
      autoDate: 'تاريخ تلقائي',
      autoDateDescription: 'عند تفعيل هذا الخيار، سيتم تعيين تاريخ اليوم تلقائياً في جميع حقول التاريخ في النظام',
      lockAutoDate: 'قفل التاريخ على مساوي النظام كله',
      lockAutoDateDisabled: 'يجب تفعيل "تاريخ تلقائي" أولاً لتفعيل هذا الخيار',
      lockAutoDateDescription: 'عند تفعيل هذا الخيار، سيتم قفل جميع حقول التاريخ في النظام على تاريخ اليوم ولا يمكن تغييره',
      restaurantSystem: 'نظام المطاعم',
      enableRestaurantSystem: 'تفعيل نظام المطاعم والطاولات',
      enableRestaurantSystemDescription: 'عند تفعيل هذا الخيار، سيتم تفعيل نظام إدارة الطاولات للمطاعم. يمكنك إدارة الطاولات من قائمة "إدارة المبيعات" → "إدارة الطاولات". عند تعطيله، سيتم إخفاء جميع خيارات الطاولات من نقطة البيع والفواتير.',
      locationsSystem: 'نظام الأماكن',
      enableLocationsSystem: 'تفعيل نظام الأماكن',
      enableLocationsSystemDescription: 'عند تفعيل هذا الخيار، سيتم تفعيل نظام إدارة الأماكن. يمكنك إدارة الأماكن من قائمة "إدارة المبيعات" → "أماكن الكتب". عند تعطيله، سيتم إخفاء جميع خيارات الأماكن من نقطة البيع والفواتير.',
      notifications: 'إعدادات الإشعارات',
      enableAllNotifications: 'تفعيل الكل',
      notificationsDescription: 'قم بتحديد عدد الأيام التي تريد أن يتم إشعارك قبل مواعيد الاستحقاق المختلفة',
      checkIssuedDaysBefore: 'اخطرني قبل تاريخ استحقاق الشيك المصدر ب (يوم)',
      checkReceivedDaysBefore: 'اخطرني قبل تاريخ استحقاق الشيك المستلم ب (يوم)',
      itemExpiryDaysBefore: 'اخطرني قبل تاريخ انتهاء صلاحية الأصناف ب (يوم)',
      loanInstallmentDaysBefore: 'اخطرني قبل تاريخ استحقاق قسط القرض ب (يوم)',
      assetMaintenanceDaysBefore: 'اخطرني قبل موعد الصيانة الدورية للأصل ب (يوم)',
      employeeVisaDaysBefore: 'اخطرني قبل انتهاء تأشيرة الموظف ب (يوم)',
      customerInstallmentDaysBefore: 'اخطرني قبل تاريخ استحقاق قسط العميل (يوم)',
      documentExpiryDaysBefore: 'اخطرني قبل تاريخ انتهاء صلاحية وثيقة ب (يوم)',
      saveNotifications: 'حفظ إعدادات الإشعارات',
      saving: 'جاري الحفظ...',
      save: 'حفظ',
    },
    // Storage Settings Tab
    storageSettings: {
      title: 'إعدادات تخزين الوثائق',
      description: 'اختر طريقة التخزين المستخدمة لحفظ الوثائق. يمكنك اختيار التخزين المحلي، FTP، أو Amazon S3.',
      storageMethod: 'طريقة التخزين',
      localStorage: 'التخزين المحلي',
      ftp: 'FTP',
      s3: 'Amazon S3',
      localSettings: 'إعدادات التخزين المحلي',
      basePath: 'المسار الأساسي',
      basePathPlaceholder: 'مثال: D:\\ERP_Documents',
      basePathDescription: 'المسار الكامل للمجلد الذي سيتم حفظ الملفات فيه',
      ftpSettings: 'إعدادات FTP',
      serverAddress: 'عنوان الخادم',
      serverAddressPlaceholder: 'ftp.example.com',
      port: 'المنفذ',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      ftpBasePath: 'المسار الأساسي',
      ftpBasePathPlaceholder: '/documents',
      useSsl: 'استخدام SSL/TLS',
      s3Settings: 'إعدادات Amazon S3',
      s3Note: '⚠️ ملاحظة: دعم Amazon S3 قيد التطوير حالياً',
      bucketName: 'اسم الـ Bucket',
      bucketNamePlaceholder: 'erp-documents',
      region: 'المنطقة',
      regionPlaceholder: 'us-east-1',
      accessKey: 'مفتاح الوصول',
      secretKey: 'المفتاح السري',
      saveStorageSettings: 'حفظ إعدادات التخزين',
      loadingStorageSettings: 'جاري تحميل إعدادات التخزين...',
    },
    // Common Messages
    messages: {
      saveSuccess: 'تم حفظ الإعدادات بنجاح',
      storageSettingsSaveSuccess: 'تم حفظ إعدادات التخزين بنجاح',
      storageSettingsSaveError: 'حدث خطأ أثناء حفظ إعدادات التخزين',
      enableAllNotificationsSuccess: 'تم تفعيل جميع الإشعارات',
      restaurantSystemEnabled: 'تم تفعيل نظام المطاعم بنجاح',
      restaurantSystemDisabled: 'تم تعطيل نظام المطاعم بنجاح',
      restaurantSystemError: 'حدث خطأ أثناء حفظ إعداد نظام المطاعم',
      locationsSystemEnabled: 'تم تفعيل نظام الأماكن بنجاح',
      locationsSystemDisabled: 'تم تعطيل نظام الأماكن بنجاح',
      locationsSystemError: 'حدث خطأ أثناء حفظ إعداد نظام الأماكن',
    },
  },
  en: {
    // Tabs
    tabs: {
      basicData: 'Basic Data',
      accountConstants: 'Account Constants',
      accountingData: 'Accounting Data',
      salesAndWarehouses: 'Sales and Warehouses',
      general: 'General',
      storageSettings: 'Storage Settings',
    },
    // Basic Data Tab
    basicData: {
      logo: 'Logo',
      mainPageLogo: 'Main Page Logo',
      commercialName: 'Commercial Name',
      address: 'Address',
      website: 'Website',
      email: 'Email',
      phone: 'Phone',
      mobile: 'Mobile',
      taxNumber: 'Tax Number',
      timeZone: 'Time zone',
      timeZoneHint: 'Invoice and voucher dates follow this time zone.',
      upload: 'Upload',
      delete: 'Delete',
      noPhoto: 'No Photo',
    },
    // Account Constants Tab
    accountConstants: {
      bank: 'Bank',
      otherRevenue: 'Other Revenue',
      payable: 'Payable',
      receivable: 'Receivable',
      bankExpenses: 'Bank Expenses and Accruals',
      currencyExchangeGain: 'Currency Exchange Gain',
      currencyExchangeLoss: 'Currency Exchange Loss',
      rawMaterialExpenses: 'Raw Material Expenses',
      totalExpenses: 'Total Expenses',
      capital: 'Capital',
      customer: 'Customer',
      supplier: 'Supplier',
      costOfSales: 'Cost of Sales',
      inventory: 'Inventory',
      salesRevenue: 'Sales Revenue',
      creditAccounts: 'Credit Accounts',
      cash: 'Cash',
      selectAccount: 'Select Account',
      fixedAssetsSection: 'Fixed Assets Accounts',
      fixedAssetDefault: 'Default Fixed Asset Account',
      fixedAssetAccumDepr: 'Default Accumulated Depreciation',
      fixedAssetDeprExpense: 'Default Depreciation Expense',
      fixedAssetRoutineExpense: 'Routine Maintenance Expense',
      fixedAssetCapitalWip: 'Capital WIP / Capital Maintenance',
      fixedAssetSaleGain: 'Gain on Asset Sale',
      fixedAssetSaleLoss: 'Loss on Asset Sale',
      fixedAssetSaleProceeds: 'Asset Sale Proceeds',
      missingAccountsWarning: 'Warning: Some fixed asset accounts are not configured or do not exist. Configure them before depreciation / maintenance / sale.',
      accountNotConfigured: 'Account not configured',
      accountNotFound: 'Account not found',
    },
    // Accounting Data Tab
    accountingData: {
      defaultCurrency: 'Default Currency',
      selectCurrency: 'Select Currency',
      currencySaved: 'Currency saved successfully',
      inventoryMethod: 'Inventory Calculation Method',
      inventorySystem: 'Inventory System',
      selectInventorySystem: 'Select Inventory System',
      periodicInventory: 'Periodic Inventory',
      continuousInventory: 'Continuous Inventory',
      fiscalYear: 'Fiscal Year',
      selectFiscalYear: 'Select Fiscal Year',
      selectFiscalYearFromHeader: 'Please select fiscal year from header above',
      fiscalYearStartDate: 'Fiscal Year Start Date',
      fiscalYearEndDate: 'Fiscal Year End Date',
      secondaryCurrency: 'Secondary Currency',
      selectSecondaryCurrency: 'Select Secondary Currency',
      secondaryCurrencySaved: 'Secondary currency saved successfully',
      periodicInventoryGuideTitle: 'Periodic Inventory: pros, cons, and integration',
      periodicInventoryAdvantagesTitle: 'Periodic inventory benefits',
      periodicInventoryDisadvantagesTitle: 'Periodic inventory drawbacks (for comparison)',
      periodicInventoryIntegrationTitle: 'How to run periodic alongside perpetual inventory',
      periodicInventoryAdvantages: {
        simple: 'Simplicity: no continuous record updates after each sale or purchase, suitable for small businesses or limited items.',
        lowCost: 'Lower cost: no complex systems or advanced software for real-time tracking.',
        easyImplementation: 'Easy to implement: minimal staff training on complex digital systems.',
        nonTraceableProducts: 'Fits non-serial-tracked goods such as raw materials or low-value items.',
        fewerDailyErrors: 'Fewer daily errors: updates happen at period end with higher focus during the physical count.',
      },
      periodicInventoryDisadvantages: {
        noRealtime: 'No real-time visibility into inventory levels.',
        hardToDetectTheft: 'Harder to detect theft or wastage during the period.',
        stockoutRisk: 'May lead to stockouts without early warning.',
      },
      periodicInventoryIntegrationSteps: {
        purpose: 'Define the operating goal: rely on periodic only, or use it for accounting comparison with perpetual.',
        dailyRecording: 'Daily recording: purchases post to the purchases account and sales to the sales account, with no direct impact on inventory or COGS.',
        periodClose: 'Period close: enter the physical count once at period end and compute COGS as beginning inventory + net purchases - ending inventory.',
        adjustments: 'Record variances: recognize shortage or surplus based on the difference between book and physical counts.',
        documentation: 'Close documentation: record the close date, responsible person, and approved values for auditability.',
        reports: 'Accounting reports: periodic COGS and book vs. physical comparisons when needed.',
      },
    },
    // Sales and Warehouses Tab
    salesAndWarehouses: {
      salesDiscountAccount: 'Sales Discount Account',
      purchaseDiscountAccount: 'Purchase Discount Account',
      servicesAccount: 'Services Account',
      quantityWarning: 'When item quantity is not available in store',
      quantityWarningOptions: {
        noWarning: 'Don\'t Warn Me',
        warn: 'Warn Me',
        preventSale: 'Prevent Sale',
      },
      sellAccount: 'Sales Account',
      cashInvoiceCashbox: 'Cash Invoice Cashbox',
      cashInvoiceCustomer: 'Cash Invoice Customer',
      selectCustomer: 'Select Customer',
      inventoryAdjustmentAccount: 'Inventory Adjustment Account',
      costOfSalesAccount: 'Cost of Sales Account',
      costDifferenceAccount: 'Cost Difference Account',
      giftAccount: 'Gift Account',
      useCustomerCreditLimit: 'Apply Customer Credit Limit',
      yes: 'Yes',
      no: 'No',
      customerCreditLimitValue: 'Credit Limit Value',
      creditLimitWarning: 'When customer exceeds credit limit',
      inventoryAccount: 'Inventory Account',
      invoiceAdditionalsAccount: 'Invoice Additionals Account',
      penalties: 'Penalties',
      cashInvoiceStore: 'Cash Invoice Store',
      selectStore: 'Select Store',
      reserveQtyFromSalesOrders: 'Reserve Quantities from Sales Orders',
      select: 'Select',
    },
    // General Tab
    general: {
      dateSettings: 'Date Settings',
      autoDate: 'Auto Date',
      autoDateDescription: 'When enabled, today\'s date will be automatically set in all date fields in the system',
      lockAutoDate: 'Lock Date Across Entire System',
      lockAutoDateDisabled: 'You must enable "Auto Date" first to enable this option',
      lockAutoDateDescription: 'When enabled, all date fields in the system will be locked to today\'s date and cannot be changed',
      restaurantSystem: 'Restaurant System',
      enableRestaurantSystem: 'Enable Restaurant System and Tables',
      enableRestaurantSystemDescription: 'When enabled, the table management system for restaurants will be activated. You can manage tables from "Sales Management" → "Table Management". When disabled, all table options will be hidden from POS and invoices.',
      locationsSystem: 'Locations System',
      enableLocationsSystem: 'Enable Locations System',
      enableLocationsSystemDescription: 'When enabled, the locations management system will be activated. You can manage locations from "Sales Management" → "Book Locations". When disabled, all location options will be hidden from POS and invoices.',
      notifications: 'Notification Settings',
      enableAllNotifications: 'Enable All',
      notificationsDescription: 'Set the number of days before you want to be notified of various due dates',
      checkIssuedDaysBefore: 'Notify me before check issued due date (days)',
      checkReceivedDaysBefore: 'Notify me before check received due date (days)',
      itemExpiryDaysBefore: 'Notify me before item expiry date (days)',
      loanInstallmentDaysBefore: 'Notify me before loan installment due date (days)',
      assetMaintenanceDaysBefore: 'Notify me before asset maintenance date (days)',
      employeeVisaDaysBefore: 'Notify me before employee visa expiry (days)',
      customerInstallmentDaysBefore: 'Notify me before customer installment due date (days)',
      documentExpiryDaysBefore: 'Notify me before document expiry date (days)',
      saveNotifications: 'Save Notification Settings',
      saving: 'Saving...',
      save: 'Save',
    },
    // Storage Settings Tab
    storageSettings: {
      title: 'Document Storage Settings',
      description: 'Choose the storage method used to save documents. You can choose local storage, FTP, or Amazon S3.',
      storageMethod: 'Storage Method',
      localStorage: 'Local Storage',
      ftp: 'FTP',
      s3: 'Amazon S3',
      localSettings: 'Local Storage Settings',
      basePath: 'Base Path',
      basePathPlaceholder: 'Example: D:\\ERP_Documents',
      basePathDescription: 'Full path to the folder where files will be saved',
      ftpSettings: 'FTP Settings',
      serverAddress: 'Server Address',
      serverAddressPlaceholder: 'ftp.example.com',
      port: 'Port',
      username: 'Username',
      password: 'Password',
      ftpBasePath: 'Base Path',
      ftpBasePathPlaceholder: '/documents',
      useSsl: 'Use SSL/TLS',
      s3Settings: 'Amazon S3 Settings',
      s3Note: '⚠️ Note: Amazon S3 support is currently under development',
      bucketName: 'Bucket Name',
      bucketNamePlaceholder: 'erp-documents',
      region: 'Region',
      regionPlaceholder: 'us-east-1',
      accessKey: 'Access Key',
      secretKey: 'Secret Key',
      saveStorageSettings: 'Save Storage Settings',
      loadingStorageSettings: 'Loading storage settings...',
    },
    // Common Messages
    messages: {
      saveSuccess: 'Settings saved successfully',
      storageSettingsSaveSuccess: 'Storage settings saved successfully',
      storageSettingsSaveError: 'Error saving storage settings',
      enableAllNotificationsSuccess: 'All notifications enabled',
      restaurantSystemEnabled: 'Restaurant system enabled successfully',
      restaurantSystemDisabled: 'Restaurant system disabled successfully',
      restaurantSystemError: 'Error saving restaurant system settings',
      locationsSystemEnabled: 'Locations system enabled successfully',
      locationsSystemDisabled: 'Locations system disabled successfully',
      locationsSystemError: 'Error saving locations system settings',
    },
  },
  fr: {
    // Tabs
    tabs: {
      basicData: 'Données de base',
      accountConstants: 'Constantes de compte',
      accountingData: 'Données comptables',
      salesAndWarehouses: 'Ventes et entrepôts',
      general: 'Général',
      storageSettings: 'Paramètres de stockage',
    },
    // Basic Data Tab
    basicData: {
      logo: 'Logo',
      mainPageLogo: 'Logo de la page principale',
      commercialName: 'Nom commercial',
      address: 'Adresse',
      website: 'Site web',
      email: 'Email',
      phone: 'Téléphone',
      mobile: 'Mobile',
      taxNumber: 'Numéro fiscal',
      timeZone: 'Fuseau horaire',
      timeZoneHint: 'Les dates des factures et des pièces suivent ce fuseau.',
      upload: 'Télécharger',
      delete: 'Supprimer',
      noPhoto: 'Pas de photo',
    },
    // Account Constants Tab
    accountConstants: {
      bank: 'Banque',
      otherRevenue: 'Autres revenus',
      payable: 'Payable',
      receivable: 'Recevable',
      bankExpenses: 'Dépenses bancaires et charges à payer',
      currencyExchangeGain: 'Gain de change',
      currencyExchangeLoss: 'Perte de change',
      rawMaterialExpenses: 'Dépenses de matières premières',
      totalExpenses: 'Dépenses totales',
      capital: 'Capital',
      customer: 'Client',
      supplier: 'Fournisseur',
      costOfSales: 'Coût des ventes',
      inventory: 'Inventaire',
      salesRevenue: 'Revenus des ventes',
      creditAccounts: 'Comptes de crédit',
      cash: 'Espèces',
      selectAccount: 'Sélectionner le compte',
      fixedAssetsSection: 'Comptes des immobilisations',
      fixedAssetDefault: 'Compte d\'immobilisation par défaut',
      fixedAssetAccumDepr: 'Amortissement cumulé par défaut',
      fixedAssetDeprExpense: 'Charge d\'amortissement par défaut',
      fixedAssetRoutineExpense: 'Charge de maintenance périodique',
      fixedAssetCapitalWip: 'Travaux en cours / maintenance capitalisable',
      fixedAssetSaleGain: 'Plus-value sur cession',
      fixedAssetSaleLoss: 'Moins-value sur cession',
      fixedAssetSaleProceeds: 'Produit de cession',
      missingAccountsWarning: 'Avertissement : certains comptes d\'immobilisations ne sont pas configurés ou n\'existent pas.',
      accountNotConfigured: 'Compte non configuré',
      accountNotFound: 'Compte introuvable',
    },
    // Accounting Data Tab
    accountingData: {
      defaultCurrency: 'Devise par défaut',
      selectCurrency: 'Sélectionner la devise',
      inventoryMethod: 'Méthode de calcul de l\'inventaire',
      fiscalYearStartDate: 'Date de début de l\'exercice fiscal',
      fiscalYearEndDate: 'Date de fin de l\'exercice fiscal',
      secondaryCurrency: 'Devise secondaire',
      selectSecondaryCurrency: 'Sélectionner la devise secondaire',
      secondaryCurrencySaved: 'Devise secondaire enregistrée avec succès',
      periodicInventoryGuideTitle: 'Inventaire périodique : avantages, limites et intégration',
      periodicInventoryAdvantagesTitle: 'Avantages de l\'inventaire périodique',
      periodicInventoryDisadvantagesTitle: 'Inconvénients de l\'inventaire périodique (comparatif)',
      periodicInventoryIntegrationTitle: 'Faire coexister l\'inventaire périodique et permanent',
      periodicInventoryAdvantages: {
        simple: 'Simplicité : pas de mise à jour continue après chaque vente ou achat, adapté aux petites entreprises ou aux articles limités.',
        lowCost: 'Coût réduit : pas besoin de systèmes complexes ni de logiciels avancés pour le suivi en temps réel.',
        easyImplementation: 'Mise en œuvre facile : peu de formation requise pour le personnel.',
        nonTraceableProducts: 'Adapté aux produits non traçables individuellement comme les matières premières ou les articles à faible valeur.',
        fewerDailyErrors: 'Moins d\'erreurs quotidiennes : mise à jour en fin de période avec plus de concentration lors de l\'inventaire physique.',
      },
      periodicInventoryDisadvantages: {
        noRealtime: 'Aucune visibilité en temps réel sur les niveaux de stock.',
        hardToDetectTheft: 'Plus difficile de détecter les vols ou le gaspillage pendant la période.',
        stockoutRisk: 'Risque de rupture de stock sans alerte préalable.',
      },
      periodicInventoryIntegrationSteps: {
        purpose: 'Définir l\'objectif d\'exploitation : utiliser le périodique seul ou pour comparaison comptable avec le permanent.',
        dailyRecording: 'Enregistrement quotidien : les achats vont au compte achats et les ventes au compte ventes, sans effet direct sur le stock ni le COGS.',
        periodClose: 'Clôture de période : saisir l\'inventaire physique en fin de période et calculer le COGS : stock initial + achats nets - stock final.',
        adjustments: 'Enregistrer les écarts : constater le déficit ou le surplus selon l\'écart entre le stock comptable et le stock physique.',
        documentation: 'Documentation de clôture : conserver la date, le responsable et les valeurs validées pour la traçabilité.',
        reports: 'Rapports comptables : COGS en périodique et comparaison stock comptable vs physique si nécessaire.',
      },
    },
    // Sales and Warehouses Tab
    salesAndWarehouses: {
      salesDiscountAccount: 'Compte de remise sur ventes',
      purchaseDiscountAccount: 'Compte de remise sur achats',
      servicesAccount: 'Compte des services',
      quantityWarning: 'Lorsque la quantité d\'article n\'est pas disponible en magasin',
      quantityWarningOptions: {
        noWarning: 'Ne pas m\'avertir',
        warn: 'M\'avertir',
        preventSale: 'Empêcher la vente',
      },
      sellAccount: 'Compte de vente',
      cashInvoiceCashbox: 'Caisse des factures au comptant',
      cashInvoiceCustomer: 'Client des factures au comptant',
      selectCustomer: 'Sélectionner le client',
      inventoryAdjustmentAccount: 'Compte d\'ajustement d\'inventaire',
      costOfSalesAccount: 'Compte du coût des ventes',
      costDifferenceAccount: 'Compte de différence de coût',
      giftAccount: 'Compte des cadeaux',
      useCustomerCreditLimit: 'Appliquer la limite de crédit client',
      yes: 'Oui',
      no: 'Non',
      customerCreditLimitValue: 'Valeur de la limite de crédit',
      creditLimitWarning: 'Lorsque le client dépasse la limite de crédit',
      inventoryAccount: 'Compte d\'inventaire',
      invoiceAdditionalsAccount: 'Compte des suppléments de facture',
      penalties: 'Pénalités',
      cashInvoiceStore: 'Magasin des factures au comptant',
      selectStore: 'Sélectionner le magasin',
      reserveQtyFromSalesOrders: 'Réserver les quantités des commandes de vente',
      select: 'Sélectionner',
    },
    // General Tab
    general: {
      dateSettings: 'Paramètres de date',
      autoDate: 'Date automatique',
      autoDateDescription: 'Lorsqu\'il est activé, la date d\'aujourd\'hui sera automatiquement définie dans tous les champs de date du système',
      lockAutoDate: 'Verrouiller la date dans tout le système',
      lockAutoDateDisabled: 'Vous devez d\'abord activer "Date automatique" pour activer cette option',
      lockAutoDateDescription: 'Lorsqu\'il est activé, tous les champs de date du système seront verrouillés à la date d\'aujourd\'hui et ne pourront pas être modifiés',
      restaurantSystem: 'Système de restaurant',
      enableRestaurantSystem: 'Activer le système de restaurant et les tables',
      enableRestaurantSystemDescription: 'Lorsqu\'il est activé, le système de gestion des tables pour les restaurants sera activé. Vous pouvez gérer les tables depuis "Gestion des ventes" → "Gestion des tables". Lorsqu\'il est désactivé, toutes les options de table seront masquées du POS et des factures.',
      locationsSystem: 'Système de localisation',
      enableLocationsSystem: 'Activer le système de localisation',
      enableLocationsSystemDescription: 'Lorsqu\'il est activé, le système de gestion des localisations sera activé. Vous pouvez gérer les localisations depuis "Gestion des ventes" → "Localisations de livres". Lorsqu\'il est désactivé, toutes les options de localisation seront masquées du POS et des factures.',
      notifications: 'Paramètres de notification',
      enableAllNotifications: 'Tout activer',
      notificationsDescription: 'Définissez le nombre de jours avant que vous souhaitiez être averti de diverses dates d\'échéance',
      checkIssuedDaysBefore: 'M\'avertir avant la date d\'échéance du chèque émis (jours)',
      checkReceivedDaysBefore: 'M\'avertir avant la date d\'échéance du chèque reçu (jours)',
      itemExpiryDaysBefore: 'M\'avertir avant la date d\'expiration de l\'article (jours)',
      loanInstallmentDaysBefore: 'M\'avertir avant la date d\'échéance de la traite du prêt (jours)',
      assetMaintenanceDaysBefore: 'M\'avertir avant la date de maintenance de l\'actif (jours)',
      employeeVisaDaysBefore: 'M\'avertir avant l\'expiration du visa de l\'employé (jours)',
      customerInstallmentDaysBefore: 'M\'avertir avant la date d\'échéance de la traite du client (jours)',
      documentExpiryDaysBefore: 'M\'avertir avant la date d\'expiration du document (jours)',
      saveNotifications: 'Enregistrer les paramètres de notification',
      saving: 'Enregistrement...',
      save: 'Enregistrer',
    },
    // Storage Settings Tab
    storageSettings: {
      title: 'Paramètres de stockage de documents',
      description: 'Choisissez la méthode de stockage utilisée pour sauvegarder les documents. Vous pouvez choisir le stockage local, FTP ou Amazon S3.',
      storageMethod: 'Méthode de stockage',
      localStorage: 'Stockage local',
      ftp: 'FTP',
      s3: 'Amazon S3',
      localSettings: 'Paramètres de stockage local',
      basePath: 'Chemin de base',
      basePathPlaceholder: 'Exemple: D:\\ERP_Documents',
      basePathDescription: 'Chemin complet vers le dossier où les fichiers seront sauvegardés',
      ftpSettings: 'Paramètres FTP',
      serverAddress: 'Adresse du serveur',
      serverAddressPlaceholder: 'ftp.example.com',
      port: 'Port',
      username: 'Nom d\'utilisateur',
      password: 'Mot de passe',
      ftpBasePath: 'Chemin de base',
      ftpBasePathPlaceholder: '/documents',
      useSsl: 'Utiliser SSL/TLS',
      s3Settings: 'Paramètres Amazon S3',
      s3Note: '⚠️ Note: Le support Amazon S3 est actuellement en développement',
      bucketName: 'Nom du bucket',
      bucketNamePlaceholder: 'erp-documents',
      region: 'Région',
      regionPlaceholder: 'us-east-1',
      accessKey: 'Clé d\'accès',
      secretKey: 'Clé secrète',
      saveStorageSettings: 'Enregistrer les paramètres de stockage',
      loadingStorageSettings: 'Chargement des paramètres de stockage...',
    },
    // Common Messages
    messages: {
      saveSuccess: 'Paramètres enregistrés avec succès',
      storageSettingsSaveSuccess: 'Paramètres de stockage enregistrés avec succès',
      storageSettingsSaveError: 'Erreur lors de l\'enregistrement des paramètres de stockage',
      enableAllNotificationsSuccess: 'Toutes les notifications activées',
      restaurantSystemEnabled: 'Système de restaurant activé avec succès',
      restaurantSystemDisabled: 'Système de restaurant désactivé avec succès',
      restaurantSystemError: 'Erreur lors de l\'enregistrement des paramètres du système de restaurant',
      locationsSystemEnabled: 'Système de localisation activé avec succès',
      locationsSystemDisabled: 'Système de localisation désactivé avec succès',
      locationsSystemError: 'Erreur lors de l\'enregistrement des paramètres du système de localisation',
    },
  },
}

